module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h2', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Histórico de Medicações")]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-condensed flip-content"
  }, [_c('thead', {
    staticClass: "flip-content"
  }, [_c('tr', [_c('th', {
    staticClass: "col-time bg-gray align-middle"
  }, [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Horário programado")])]), _vm._v(" "), _c('th', {
    staticClass: "col-time bg-gray align-middle"
  }, [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Horário ministrado")])]), _vm._v(" "), _c('th', {
    staticClass: "bg-gray align-middle"
  }, [_c('i', {
    staticClass: "fa fa-graduation-cap",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Ministrada por")])]), _vm._v(" "), _c('th', {
    staticClass: "bg-gray align-middle"
  }, [_c('i', {
    staticClass: "fa fa-user",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Aluno")])]), _vm._v(" "), _c('th', {
    staticClass: "bg-gray align-middle"
  }, [_c('i', {
    staticClass: "fa fa-medkit",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Medicação e Dosagem")])]), _vm._v(" "), _c('th', {
    staticClass: "bg-gray align-middle"
  }, [_c('i', {
    staticClass: "fa fa-heartbeat",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Motivo")])])])]), _vm._v(" "), _c('tbody', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.historyList.list.length),
      expression: "historyList.list.length"
    }]
  }, _vm._l((_vm.historyList.list), function(medicine, index) {
    return _c('tr', [_c('td', {
      staticClass: "prog align-middle"
    }, [(medicine.medicinesTaken) ? _c('i', {
      staticClass: "fa fa-check font-green",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e(), _vm._v(" "), (medicine.rejectionReason) ? _c('i', {
      staticClass: "fa fa-ban font-red",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e(), _vm._v("\n\n\t\t\t\t\t\t\t" + _vm._s(_vm._f("date")(medicine.hour, 'HH:mm', true)) + "\n\n\t\t\t\t\t\t\t"), (medicine.rejectionReason) ? _c('button', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }],
      staticClass: "btn default btn-xs",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.cancelRejectionMedicine(medicine.id)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\tCancelar Rejeição\n\t\t\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "align-middle"
    }, [(medicine.medicinesTaken) ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("date")(medicine.medicinesTaken[0].time, 'HH:mm', true)) + "\n\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (medicine.rejectionReason) ? _c('span', [_vm._v("-")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "align-middle"
    }, [(medicine.medicinesTaken) ? _c('span', [(!medicine.medicinesTaken[0].user) ? _c('span', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }]
    }, [_vm._v("Não informado")]) : _vm._e(), _vm._v(" "), (medicine.medicinesTaken[0].user) ? _c('span', [_vm._v(_vm._s(medicine.medicinesTaken[0].user.name))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (medicine.rejectionReason) ? _c('span', [_c('strong', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }],
      staticClass: "text-danger"
    }, [_vm._v("Rejeitado")]), _vm._v(" "), _c('small', {
      staticClass: "display-block m-t-5"
    }, [_c('span', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }]
    }, [_vm._v("Motivo:")]), _vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(medicine.rejectionReason || '-') + "\n\t\t\t\t\t\t\t\t")])]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "align-middle"
    }, [_c('img', {
      staticClass: "img-circle",
      attrs: {
        "width": "25px",
        "height": "25px",
        "src": medicine.student.photoURL
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(medicine.student.name))]), _c('br'), _vm._v(" "), _c('small', {
      staticClass: "font-grey-cascade display-block m-t-5"
    }, [_c('span', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }]
    }, [_vm._v("Solicitado por")]), _vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(medicine.responsible.name) + "\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center align-middle"
    }, [_c('span', [_vm._v(_vm._s(medicine.medicine) + " - " + _vm._s(medicine.dosage))]), _c('br'), _vm._v(" "), _c('a', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }],
      staticClass: "btn btn-link btn-xs",
      attrs: {
        "target": "_blank",
        "href": medicine.medicalPrescriptionURL
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\tVer receita\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center align-middle"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(medicine.treatment) + "\n\t\t\t\t\t\t")])])
  })), _vm._v(" "), _c('tfoot', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.historyList.list.length),
      expression: "!historyList.list.length"
    }]
  }, [_c('tr', [_c('td', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("Nenhum histórico de mediação na data informada")])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e71cb9f6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./sources/domains/medicine/medicine-history/medicine-history.vue
// module id = 1116
// module chunks = 1